module.exports = __webpack_public_path__ + "static/prospect_view-2dfe08f23dec8fbb5572c5398f8f8653.png";